import React from "react";

const Prices = () => {
  return (
    <div className="prices">
      <div className="container">
        <div className="row">
          <div className="col-4">
            <div className="price">
              <div className="price-img">
                <img src="/images/pizza1.png" alt="pizza" />
              </div>
              <h1 className="price-heading">Pizza Margeritta</h1>
              <p className="price-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse at arcu faucibus, ultrices mi id.
              </p>
              <p className="price-dollar">$ 50.00</p>
            </div>
          </div>

          <div className="col-4">
            <div className="price">
              <div className="price-img">
                <img src="/images/pizza2.png" alt="pizza" />
              </div>
              <h1 className="price-heading">Pizza Margeritta</h1>
              <p className="price-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse at arcu faucibus, ultrices mi id.
              </p>
              <p className="price-dollar">$ 50.00</p>
            </div>
          </div>
          <div className="col-4">
            <div className="price">
              <div className="price-img">
                <img src="/images/pizza3.png" alt="pizza" />
              </div>
              <h1 className="price-heading">Pizza Margeritta</h1>
              <p className="price-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse at arcu faucibus, ultrices mi id.
              </p>
              <p className="price-dollar">$ 50.00</p>
            </div>
          </div>
          <div className="col-4">
            <div className="price">
              <div className="price-img">
                <img src="/images/pizza3.png" alt="pizza" />
              </div>
              <h1 className="price-heading">Pizza Margeritta</h1>
              <p className="price-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse at arcu faucibus, ultrices mi id.
              </p>
              <p className="price-dollar">$ 50.00</p>
            </div>
          </div>
          <div className="col-4">
            <div className="price">
              <div className="price-img">
                <img src="/images/pizza3.png" alt="pizza" />
              </div>
              <h1 className="price-heading">Pizza Margeritta</h1>
              <p className="price-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse at arcu faucibus, ultrices mi id.
              </p>
              <p className="price-dollar">$ 50.00</p>
            </div>
          </div>
          <div className="col-4">
            <div className="price">
              <div className="price-img">
                <img src="/images/pizza3.png" alt="pizza" />
              </div>
              <h1 className="price-heading">Pizza Margeritta</h1>
              <p className="price-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse at arcu faucibus, ultrices mi id.
              </p>
              <p className="price-dollar">$ 50.00</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Prices;
